import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Divider, message, Spin, Row, Col, Radio } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from 'src/utils/BindThisHelper'; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import AddDistrictDTO from 'src/models/district/AddDistrictDTO';
import UpdateDistrictDTO from 'src/models/district/UpdateDistrictDTO';
import DistrictApiController from 'src/api/DistrictApiController';
import AdminFullSyncReports from './AdminFullSyncReports';
import ClientApiController from 'src/api/ClientApiController';
import { kMaxLength } from 'buffer';

const RadioGroup = Radio.Group;

interface RouteParams {
  id: string;
}

interface AddEditDistrictProps extends PageProps<RouteParams>, LocalizeContextProps {}

interface AddEditDistrictState {
  loading: boolean;
  isSubmitting: boolean;
  currentDistrict: UpdateDistrictDTO;
  redirect: boolean;
}

interface DistrictFormProps {
  currentDistrict: UpdateDistrictDTO;
  translate: (id: any) => any;
  onChange: (changedFields: any[]) => void;
}

// Form
let DistrictForm = Form.create({
  onFieldsChange(props: DistrictFormProps, changedFields: any[]) {
    props.onChange(changedFields);
  },
})(
  class extends React.Component<DistrictFormProps & FormComponentProps> {
    constructor(props: DistrictFormProps & FormComponentProps) {
      super(props);
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
      let translatedLabel = this.props.translate(translationId);

      if (visible) {
        return (
          <Form.Item label={translatedLabel}>
            {this.props.form.getFieldDecorator(id, {
              initialValue: initialValue,
              rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }],
            })(inputType)}
          </Form.Item>
        );
      }
    }

    render() {
      return (
        <Row>
          <Col span={12}>
            <Form className="admin-form">
              {this.renderStandardFormItem('admin.addEditDistrict.formItem1', 'districtName', this.props.currentDistrict.districtName, <Input autoComplete="off" />)}
              {this.renderStandardFormItem('admin.addEditDistrict.cleverDistrictId', 'cleverDistrictId', this.props.currentDistrict.cleverDistrictId, <Input autoComplete="off" />, true, false)}
              {this.renderStandardFormItem(
                'admin.addEditDistrict.syncStudents',
                'syncStudents',
                this.props.currentDistrict.syncStudents,
                <RadioGroup name="syncStudents" value={this.props.currentDistrict.syncStudents}>
                  <Radio value={true} checked={this.props.currentDistrict.syncStudents === true}>
                    {this.props.translate('admin.addEditDistrict.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentDistrict.syncStudents === false}>
                    {this.props.translate('admin.addEditDistrict.no')}
                  </Radio>
                </RadioGroup>,
                true,
                false
              )}
              {this.renderStandardFormItem(
                'admin.addEditDistrict.syncTeachers',
                'syncTeachers',
                this.props.currentDistrict.syncTeachers,
                <RadioGroup name="syncTeachers" value={this.props.currentDistrict.syncTeachers}>
                  <Radio value={true} checked={this.props.currentDistrict.syncTeachers === true}>
                    {this.props.translate('admin.addEditDistrict.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentDistrict.syncTeachers === false}>
                    {this.props.translate('admin.addEditDistrict.no')}
                  </Radio>
                </RadioGroup>,
                true,
                false
              )}

              {this.renderStandardFormItem(
                'admin.addEditDistrict.fullSync',
                'fullSync',
                this.props.currentDistrict.fullSync,
                <RadioGroup name="fullSync" value={this.props.currentDistrict.fullSync}>
                  <Radio value={true} checked={this.props.currentDistrict.fullSync === true}>
                    {this.props.translate('admin.addEditDistrict.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentDistrict.fullSync === false}>
                    {this.props.translate('admin.addEditDistrict.no')}
                  </Radio>
                </RadioGroup>,
                true,
                false
              )}

              {this.renderStandardFormItem('admin.addEditDistrict.classLinkTenantId', 'classLinkTenantId', this.props.currentDistrict.classLinkTenantId, <Input autoComplete="off" />, true, false)}
              {this.renderStandardFormItem(
                'admin.addEditDistrict.syncClassLinkStudentsAndTeachers',
                'syncClassLinkStudentsAndTeachers',
                this.props.currentDistrict.syncClassLinkStudentsAndTeachers,
                <RadioGroup name="syncClassLinkStudentsAndTeachers" value={this.props.currentDistrict.syncStudents}>
                  <Radio value={true} checked={this.props.currentDistrict.syncClassLinkStudentsAndTeachers === true}>
                    {this.props.translate('admin.addEditDistrict.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentDistrict.syncClassLinkStudentsAndTeachers === false}>
                    {this.props.translate('admin.addEditDistrict.no')}
                  </Radio>
                </RadioGroup>,
                true,
                false
              )}
            </Form>
          </Col>
        </Row>
      );
    }
  }
);

class AddEditDistrict extends React.Component<AddEditDistrictProps, AddEditDistrictState> {
  private formRef: React.Component<FormComponentProps>;

  constructor(props: AddEditDistrictProps) {
    super(props);
    bindAllOfThis(this, AddEditDistrict.prototype);

    let districtId = parseInt(this.props.match.params.id, 10);

    let currentDistrict: UpdateDistrictDTO = {
      districtId: districtId,
      districtName: '',
      cleverDistrictId: '',
      syncStudents: false,
      syncTeachers: false,
      fullSync: false,
      fullSyncEndTimeStudents: null,
      fullSyncEndTimeTeachers: null,
      modifiedBy: '',
      modifiedDate: null,
      classLinkTenantId: null,
      syncClassLinkStudentsAndTeachers: false,
    };

    this.state = {
      loading: true,
      isSubmitting: false,
      redirect: false,
      currentDistrict: currentDistrict,
    };
  }

  componentWillMount() {
    this.fillForm();
  }

  private fillForm(): void {
    if (this.state.currentDistrict.districtId) {
      DistrictApiController.getDistrict(this.state.currentDistrict.districtId)
        .then((result) => {
          this.setState({
            loading: false,
            currentDistrict: result.data,
          });
        })
        .catch((e) => {
          message.error(this.props.translate('admin.addEditDistrict.messageRetrieveError'));
        });
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  private handleInputChange(changedFields: any[]): void {
    let newState = {};

    for (var key in changedFields) {
      if (changedFields.hasOwnProperty(key)) {
        let field: any = changedFields[key];

        newState[key] = field.value;

        if (key === 'fullSync') {
          if (field.value === true) {
            newState['syncStudents'] = true;
            newState['syncTeachers'] = true;
          } else {
            newState['syncStudents'] = false;
            newState['syncTeachers'] = false;
          }
        }

        newState[key] = field.value;
      }
    }

    this.setState({
      currentDistrict: { ...this.state.currentDistrict, ...newState },
    });
  }

  private addDistrict(): void {
    let addDistrictDTO: AddDistrictDTO = {
      districtName: this.state.currentDistrict.districtName,
    };

    DistrictApiController.addDistrict(addDistrictDTO)
      .then((result) => {
        message.success(this.props.translate('admin.addEditDistrict.messageAdd'));
        this.setState({ redirect: true, isSubmitting: false });
      })
      .catch((e) => {
        message.error(this.props.translate('admin.addEditDistrict.messageAddError'));
        this.setState({ isSubmitting: false });
      });
  }

  private updateDistrict(): void {
    DistrictApiController.updateDistrict(this.state.currentDistrict)
      .then((result) => {
        message.success(this.props.translate('admin.addEditDistrict.messageUpdate'));
        this.setState({ redirect: true, isSubmitting: false });
      })
      .catch((e) => {
        message.error(this.props.translate('admin.addEditDistrict.messageUpdateError'));
        this.setState({ isSubmitting: false });
      });
  }

  private validateAndSubmit() {
    const hasCleverInfo = this.state.currentDistrict.cleverDistrictId != null && this.state.currentDistrict.cleverDistrictId.trim() !== '';
    const hasClassLinkInfo = this.state.currentDistrict.classLinkTenantId != null && this.state.currentDistrict.classLinkTenantId > 0;

    if (hasCleverInfo && hasClassLinkInfo) {
      this.formRef.props.form.setFields({
        cleverDistrictId: {
          value: this.state.currentDistrict.cleverDistrictId,
          errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
        },
        classLinkTenantId: {
          value: this.state.currentDistrict.classLinkTenantId,
          errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
        },
      });
      return;
    }

    this.formRef.props.form.validateFields((error: any, values: any) => {
      if (!error) {
        this.setState({ isSubmitting: true });
        this.state.currentDistrict.districtId ? this.updateDistrict() : this.addDistrict();
      }
    });
  }

  private handleSubmit(e): void {
    e.preventDefault();

    this.validateAndSubmit();
    return;

    // TODO: The duplicate CleverDistrictId and ClassLInkTenantId checks require a KuderAdmin and don't take into account emulation
    const hasCleverInfo = this.state.currentDistrict.cleverDistrictId != null && this.state.currentDistrict.cleverDistrictId.trim() !== '';
    const hasClassLinkInfo = this.state.currentDistrict.classLinkTenantId != null && this.state.currentDistrict.classLinkTenantId > 0;

    if (!hasCleverInfo && !hasClassLinkInfo) {
      this.validateAndSubmit();
    } else {
      if (hasCleverInfo) {
        const client: UpdateDistrictDTO = {
          ...this.state.currentDistrict,
          cleverDistrictId: this.state.currentDistrict.cleverDistrictId,
        };

        ClientApiController.isDistrictDuplicateCleverDistrictId(client)
          .then((result) => {
            if (result.data === true) {
              this.formRef.props.form.setFields({
                cleverDistrictId: {
                  value: this.state.currentDistrict.cleverDistrictId,
                  errors: [new Error('"This CleverId is already being used"')],
                },
              });
            } else {
              this.validateAndSubmit();
            }
          })
          .catch((e) => this.validateAndSubmit());
      } else if (hasClassLinkInfo) {
        const client: UpdateDistrictDTO = {
          ...this.state.currentDistrict,
          classLinkTenantId: this.state.currentDistrict.classLinkTenantId,
        };

        ClientApiController.isDistrictDuplicateClassLinkTenantId(client)
          .then((result) => {
            if (result.data === true) {
              this.formRef.props.form.setFields({
                classLinkTenantId: {
                  value: this.state.currentDistrict.classLinkTenantId,
                  errors: [new Error('"This ClassLinkTenantId is already being used"')],
                },
              });
            } else {
              this.validateAndSubmit();
            }
          })
          .catch((e) => this.validateAndSubmit());
      }
    }
  }

  private handleCancel(e): void {
    this.setState({ redirect: true });
  }

  private renderAdminFullSyncReports(): JSX.Element {
    const fullSyncCompletionEndDateStudents = this.state.currentDistrict.fullSyncEndTimeStudents !== null ? new Date(this.state.currentDistrict.fullSyncEndTimeStudents.toLocaleString()) : '';

    const fullSyncCompletionEndDateTeachers = this.state.currentDistrict.fullSyncEndTimeTeachers !== null ? new Date(this.state.currentDistrict.fullSyncEndTimeTeachers.toLocaleString()) : '';

    const lastSyncModifiedBy = this.state.currentDistrict.modifiedBy !== null ? this.state.currentDistrict.modifiedBy : '';

    const lastSyncModifiedDate = this.state.currentDistrict.modifiedDate !== null ? new Date(this.state.currentDistrict.modifiedDate.toLocaleString()) : '';

    let dataTableProps = {
      districtId: this.state.currentDistrict.districtId,
      districtName: this.state.currentDistrict.districtName,
      fullSyncCompletionEndDateStudents: fullSyncCompletionEndDateStudents,
      fullSyncCompletionEndDateTeachers: fullSyncCompletionEndDateTeachers,
      lastSyncModifiedBy: lastSyncModifiedBy,
      lastSyncModifiedDate: lastSyncModifiedDate,
    };

    if (this.state.currentDistrict.districtId) {
      return <AdminFullSyncReports {...dataTableProps} />;
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={Routes.ADMIN_DISTRICTS} push />;
    } else if (this.state.loading) {
      return <Spin />;
    }

    let formProps = {
      currentDistrict: this.state.currentDistrict,
      translate: this.props.translate,
      onChange: this.handleInputChange,
    } as DistrictFormProps;

    return (
      <div className="full-sync-report">
        <h2>{this.state.currentDistrict.districtId ? this.state.currentDistrict.districtName : this.props.translate('admin.addEditDistrict.addHeader')}</h2>

        <DistrictForm wrappedComponentRef={(ref) => (this.formRef = ref)} {...formProps} />

        <div>
          <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
            {this.props.translate('admin.common.saveButton')}
          </Button>
          <Divider type="vertical" />
          <Button onClick={this.handleCancel}>{this.props.translate('common.back')}</Button>
        </div>

        {this.renderAdminFullSyncReports()}
      </div>
    );
  }
}

export default withLocalize(AddEditDistrict);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditDistrict.tsx